import React from "react"
import logo from "./../../images/mm-logo.svg"

const Brand = (props) => {
  return (
    <div>
      <img src={logo} alt="" className="mm-logo" />
    </div>
  )
}

export default Brand
